import ApiCoreService from "./api.core.service";

export default class TransactionService extends ApiCoreService {
  static get token() {
    const token = localStorage.getItem("_token"); // Fetch from localStorage
    return token ? token : null;
  }

  static get userId() {
    const userId = localStorage.getItem("_id"); // Fetch from localStorage
    return userId ? userId : null;
  }
  static async createWalletTransaction(amount, actionType,desc='') {
    let EnumTxType = {
      TOP_UP: "Top_Up",
      BUY: "buy",
      SELL: "sell",
    };
    let txType=Object.keys(EnumTxType).find(key => EnumTxType[key] === actionType);
    let descString = '';
    if (typeof desc === 'object' && desc !== null) {
      descString = JSON.stringify(desc).replace(/"/g, '\\"');
    } else {
      descString = desc;
    }
    
    try {
      return await this.graphCall(
        "mutationWithAuth.fabricate.createWalletTransaction",
        `
                mutation {
                    mutationWithAuth(token: "auto") {
                        fabricate {
                            createWalletTransaction(
                                status: PENDING,
                                ts: "${new Date().toISOString()}",
                                amount: ${amount},
                                txType: ${txType},
                                desc: "${descString}",
                            ) {
                                id
                                meta
                             status
                               ts
                               txType
                            amount
                            }
                        }
                    }
                }
            `
      );
    } catch (error) {
      throw new Error(error);
    }
  }

  static async getTransaction(id) {
    try {
      return await this.graphCall(
        "withAuth.getWalletTransaction",
        `
                {
  withAuth(token:"auto"){
    getWalletTransaction(id:"${id}") {
      id
      meta
      status
      ts
      txType
      amount
    }
  }
}
            `
      );
    } catch (error) {
      throw new Error(error);
    }
  }

  static async getWallet() {
    try {
      return await this.graphCall(
        "withAuth.listWallet",
        `
           {
  withAuth(token: "auto"){
    listWallet(criteria: "{\\"user\\":\\"${this.userId}\\"}") {
      id
      transactions{id ts amount desc}
    }
  }
}
            `,
        {}
      );
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
  }

  static async updateWallet(walletId, transactions) {
    try {
      return await this.graphCall(
        "mutationWithAuth.update.updateWallet",
        `
                mutation {
                    mutationWithAuth(token: "auto") {
                        update {
                            updateWallet(
                                id: "${walletId}",
                                transactions: ${JSON.stringify(transactions)}
                            ) {
                                id
                                transactions {
                                    id
                                    ts
                                    amount
                                    txType
                                    status
                                }
                            }
                        }
                    }
                }
            `
      );
    } catch (error) {
      throw new Error(error);
    }
  }
  
  static async updateWalletTransaction(transactionId) {
    try {
      return await this.graphCall(
        "updateWalletTransaction",
        `
                mutation {
                    mutationWithAuth(token: "auto") {
                        update {
                            updateWalletTransaction(
                                id: "${transactionId}",
                                status: SUCCESS
                            ) {
                                id
                                status
                            }
                        }
                    }
                }
            `
      );
    } catch (error) {
      throw new Error(error);
    }
  }
  static get token() {
    const token = localStorage.getItem("_token");
    return token ? token : null;
  }
}